import { cn } from '../../../lib/stylingUtils';

export const Content = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) => (
  <div
    className={cn(
      '@Content',
      'flex min-h-0 grow flex-col overflow-auto',
      className,
    )}
    {...props}
  />
);
